import { isAxiosError } from 'axios';
import { unwrapApiResponse } from '@/lib/unwrap-api-response';

/**
 * Extracts a human-readable message from an API error body.
 * Handles the Ninja API error envelope `{ error: true, data: { detail } }`
 * plus flat `{ detail }` / `{ message }` / `{ error }` bodies.
 * Returns `undefined` when no message can be derived — callers should
 * fall back to a generic message.
 */
export function getApiErrorMessage(error: unknown): string | undefined {
  if (!isAxiosError(error)) return undefined;
  const body = error.response?.data;
  if (!body || typeof body !== 'object') return undefined;
  const unwrapped = unwrapApiResponse<{
    detail?: unknown;
    message?: unknown;
    error?: unknown;
  }>(body);
  const message = unwrapped?.detail ?? unwrapped?.message ?? unwrapped?.error;
  return typeof message === 'string' && message.length > 0
    ? message
    : undefined;
}
